import { get } from 'lodash';
import httpStatus from 'http-status-codes';
import AppConstants from '../constants/AppConstants';

const { BRAND_NAME } = AppConstants;

export function errorResponseStatus (error: Error) {
  return get(error, 'response.status');
}

export function errorResponseStatusMatches (error: Error, status: any) {
  return errorResponseStatus(error) === status;
}

export function isTransportError (error: Error) {
  return !!get(error, 'isTransportError');
}

export function isTransportErrorNotFound (error: Error) {
  return errorResponseStatusMatches(error, httpStatus.NOT_FOUND);
}

export function isTransportErrorUnauthorized (error: Error) {
  return errorResponseStatusMatches(error, httpStatus.UNAUTHORIZED);
}

export function isTransportErrorNoResponse (error: Error) {
  return isTransportError(error) && !get(error, 'response');
}

export function transportErrorToastMessage (error: Error, options: object) {
  if (isTransportErrorNoResponse(error)) {
    return `
       The ${BRAND_NAME} server appears to be unreachable.
       You may want to check your internet connection.
    `;
  }

  const errorStatus = errorResponseStatus(error);

  if (errorStatus === httpStatus.UNAUTHORIZED) {
    return `
      There was a problem authenticating with ${BRAND_NAME}.
      Make sure you are signed in or try refreshing the page.
    `;
  }

  if (errorStatus === httpStatus.FORBIDDEN) {
    return 'You do not have permission to perform this action.';
  }

  const writeActionWarning = (
    ['POST', 'PATCH', 'DELETE'].includes(get(options, 'method'))
      ? 'Your last action may have not been completed.\n'
      : ''
  );

  if ([httpStatus.INTERNAL_SERVER_ERROR, httpStatus.GATEWAY_TIMEOUT].includes(errorStatus)) {
    return `
      The ${BRAND_NAME} server responded with an error.
      ${writeActionWarning}
      This error has been automatically reported to our development team.
    `;
  }

  // These errors should be caught by the parent
  if ([httpStatus.BAD_REQUEST, httpStatus.NOT_FOUND].includes(errorStatus)) {
    return;
  }

  return `
    An error occurred communicating with the ${BRAND_NAME} server.
    ${writeActionWarning}
  `;
}
